/* template */
<template minapp="mpx" xlang="wxml"><mpx-view @tap="clickExtra" class="large-coupon-container"><div class="left-area" v-if="(couponInfo.price)"><span class="discount">{{ couponInfo.price }}</span><span class="left-text">{{ couponInfo.priceUnit }}</span></div><div class="right-area"><span :class="(isSingle?'nameSingle':'name')" v-if="(couponInfo.name)">{{ couponInfo.name }}</span><div class="singleText" v-if="(isSingle)"><span class="maxAmount" v-if="(couponInfo.maxAmount)">{{ couponInfo.maxAmount }}</span><span class="remark" v-if="(couponInfo.remark)">{{ couponInfo.remark }}</span></div></div></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m3cad6c46"}'>
  .large-coupon-container
    flex 1
    display flex
    align-items center
    overflow hidden
    margin-right 10px
    border-radius 8px
    background #FFECEA
    border 0.75px solid rgba(255, 0, 0, 0.3)
    justify-content center
    position relative
    // 替换成 drop-shadow
    -webkit-mask radial-gradient(circle at 3.8px 50%, transparent 3.8px, #000 0) -3.8px
    mask radial-gradient(circle at 3.8px 50%, transparent 3.8px, #000 0) -3.8px
    &:last-child
      margin-right 0
    &::before, &::after
      content ''
      position absolute
      top 20.5px
      width 7px
      height 7px
      border-radius 50%
      border 0.75px solid rgba(255, 0, 0, 0.3)
    &::before
      left -4px
    &::after
      right -4px
    .left-area
      flex none
      padding 0 6px 0 12px
      display flex
      align-items baseline
      justify-content center
      .discount, .unit
        color #FF5900
        font-weight 400
      .discount
        font-family Barlow Semi Condensed
        font-size 28px
        line-height 28px
      .unit
        font-family PingFang SC
        font-size 11px
        line-height 11px
      .left-text
        font-family PingFang SC
        font-size 11px
        font-weight 400
        line-height 11px
        color #FF5900
        margin-left 2px
    .right-area
      flex-basis 55%
      height 42px
      border-left 0.5px solid #FFB3B3
      padding-left 12px
      display flex
      flex-wrap wrap
      align-items center
      flex 1
      overflow hidden
      .nameSingle
        font-family PingFang SC
        font-size 14px
        font-weight 800
        line-height 14px
        padding-top 4px
        margin-bottom -4px
        color #FF5900
        width calc(100% - 5px)
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
      .name
        font-family PingFang SC
        font-size 12px
        font-weight normal
        line-height 12px
        padding-top 4px
        margin-bottom 4px
        color #FF5900
        width calc(100% - 5px)
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
      .remark
        font-family PingFang SC
        font-size 9px
        font-weight normal
        line-height 10px
        color #B69786
        width 90px
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
        zoom 0.83333
      .maxAmount
        font-family PingFang SC
        font-size 10px
        font-weight normal
        line-height 10px
        color #B69786
        width 90px
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
        zoom 0.83333
        &::after
          content ''
          display inline-block
          background #B69786
          width 1px
          height 10px
          margin 0 5px
          line-height 10px
          zoom 0.83333
      .singleText
        display inline-block
        width 100%
        zoom 0.83333
        font-family PingFang SC
        font-size 9px
        font-weight normal
        line-height 10px
        color #B69786
        width calc(100% - 20px)
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m3cad6c46"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./large-coupon.mpx.js?isComponent&outputPath=components%2Flarge-coupon3cad6c46%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./large-coupon.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Flarge-coupon3cad6c46%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m3cad6c46"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/large-coupon3cad6c46/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
